<a routerLink="/" class="logo__link">
  <img src="assets/img/logo_light10.png" class="logo__image" alt="logo" />
</a>
